module.exports = __webpack_public_path__ + "static/media/destroyerExplosions.7b837a5b.svg";